import { Box, useTheme } from "@mui/material";
import React from "react";
import AppFooter from "../../components/footer";
import Header from "../../components/header";
import { appImages } from "../../assets";
import Help from "./Help";
import NavBar from "../../components/NavBar";

const HelpCenter = () => {
  const { palette } = useTheme();

  return (
    <>
      <Box>
        <NavBar />
      </Box>
      <Box
        marginTop={{ xs: 8, sm: 8 }}
        height={"110vh"}
        display={"flex"}
        flexDirection={"column"}
        position={"relative"}
        sx={{
          background: palette.gradient.background,
          backgroundImage: `url(https://service-provider-2024.s3.us-east-1.amazonaws.com/uploads/1744141495520_faq-bg.jpg)`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        {/* <Header /> */}

        <Box
          flexGrow={10}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          position={"relative"}
          zIndex={999}
        >
          <Help />
        </Box>

        <img
          src={appImages.helpPageWaveImg}
          width={"100%"}
          style={{
            position: "absolute",
            bottom: 0,
          }}
        />
      </Box>
      <AppFooter bgcolor={true} />
    </>
  );
};

export default HelpCenter;
